export default function () {
    return (
        <svg width="382" height="82" viewBox="0 0 382 82" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M215.487 42.2061H187.684L196.107 10.6895H187.883L179.345 42.543C178.212 46.7697 180.724 50.2001 184.95 50.2001H221.551L232.133 10.6895H223.91L215.487 42.2061Z"
                fill="white"
            />
            <path
                d="M319.448 34.5873C323.674 34.5873 328.024 31.1569 329.157 26.9302L331.454 18.3466C332.587 14.1122 330.076 10.6895 325.849 10.6895H289.095L286.89 18.9132H323.184L321.186 26.3559H284.899L278.513 50.2001H286.522L290.703 34.5873H301.185L312.61 50.2001H324.264L312.893 34.5873H319.448Z"
                fill="white"
            />
            <path
                d="M370.528 10.6895H340.022L329.432 50.2001H359.938C367.549 50.2001 375.367 44.0285 377.412 36.4173L380.612 24.4646C382.649 16.8534 378.131 10.6895 370.528 10.6895ZM369.555 35.843C368.526 39.3232 365.415 41.7773 361.791 41.9687H339.585L345.765 18.9285H367.97C371.355 18.9285 373.33 21.6698 372.458 25.0542L369.555 35.843Z"
                fill="white"
            />
            <path
                d="M150.646 10.6895C143.035 10.6895 135.21 16.8151 133.173 24.4723L129.972 36.425C127.928 44.0362 132.446 50.2078 140.057 50.2078H170.555L176.941 26.3865H168.939L164.766 41.9764H142.561C139.176 41.9764 137.201 39.2275 138.081 35.8507L140.976 25.0465C142.003 21.565 145.115 19.11 148.74 18.9208H178.901L181.106 10.6895H150.646Z"
                fill="white"
            />
            <path d="M256.429 10.6816L225.288 50.1923H234.346L258.144 20.008L265.755 50.1923H274.814L264.852 10.6816H256.429Z" fill="white" />
            <path d="M100.362 34.5491H122.468L124.666 26.333H102.567L100.362 34.5491Z" fill="white" />
            <path d="M53.9068 0H31.6245L51.0888 26.3481L65.3005 15.4061L53.9068 0Z" fill="white" />
            <path d="M76.6328 60.8737H98.9227L81.0586 36.7002L65.6831 46.0649L76.6328 60.8737Z" fill="white" />
            <path d="M119.336 0H91.334L42.9105 37.137H53.5156L0 82L91.6709 26.3175H80.9509L119.336 0Z" fill="url(#paint0_linear_540_1756)" />
            <defs>
                <linearGradient id="paint0_linear_540_1756" x1="112.736" y1="-5.23546e-07" x2="0.19064" y2="81.9358" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EAC64C" />
                    <stop offset="0.554786" stopColor="#C09325" />
                    <stop offset="1" stopColor="#AF7D14" />
                </linearGradient>
            </defs>
        </svg>
    );
}
